import { z } from 'zod/v4';

import { ZOD_ERROR } from '../models/constants';
import { assetDeleteResultSchema } from './asset-delete-result.schema';
import { BaseMessage, baseMessageSchema } from './base-message.schema';

const assetDeleteOperationSchema = z.object({
  Id: z.string(),
  Type: z.string(),
  Result: assetDeleteResultSchema,
});

export const assetDeleteOperationEventSchema = baseMessageSchema.transform(
  (data) => {
    const message = JSON.parse(data.message) as BaseMessage;
    const { success, data: result } = assetDeleteOperationSchema
      .transform((d) => ({
        id: d.Id,
        type: d.Type,
        result: {
          errorCode: d.Result.ErrorCode,
          totalAssetsDeleted: d.Result.TotalAssetsDeleted,
        },
      }))
      .safeParse(message);

    if (success) {
      return result;
    }

    return {
      id: '',
      type: '',
      result: {
        errorCode: ZOD_ERROR,
        totalAssetsDeleted: 0,
      },
    };
  }
);
